import TextField from "@material-ui/core/TextField";
import MuiAlert from "@material-ui/lab/Alert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {Radar} from "@nivo/radar";
import moment from "moment";
import React, {useEffect, useState} from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Controller, useForm} from "react-hook-form";
//import slices
import {useDispatch, useSelector} from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import {AutoSizer} from "react-virtualized";
import {auth} from "../firebase";
import {bgItemTypes, companyDimensions, softSkillsDataset,} from "../db/models/const";
import {companySectors} from "../db/datasets/company-sectors";
import {professionScopes} from "../db/datasets/professions";
import {qualificationScopes} from "../db/datasets/qualifications";
import {closeAlert, openAlert} from "../slices/alert";
import {closeDialog} from "../slices/dialog";
import {selectUid} from "../slices/auth";
import {Collections} from "../api/collections";
import {updateStudentBgItem, uploadFile} from "../api/common";
import {updateCompany} from "../api/company";
import {updateStudent} from "../api/student";
import {sanitizeUrl} from "../helpers/misc";
import "./CommonComponents.scss";
import CompanyArea from "./Cards/Company/CompanyArea";
import {Snackbar} from "@material-ui/core";
import Button from "./Common/Button";
import {StudentInterface} from "../db/models/student/student";
import {CompanyAreaI} from "../db/models/company/area";
import {
    StudentBaseOtherInterface,
    StudentChartSoftSkillsType,
    StudentOtherInterface,
} from "../db/models/student/cv";
import {DocTimestamp, MissingType} from "../db/models/extra";
import {useTranslation} from "react-i18next";
import {selectRole, selectUser} from "../slices/profile";
import {genders as genderDataset} from "../db/datasets/genders";

var emojiCompact = require("emoji.json/emoji-compact.json");

// export const FileUploader = ({ storagePath, docField, docId }) => {
// 	const [file, setFile] = useState(null);
// 	const dispatch = useDispatch();

// 	const onChange = (e) => {
// 		if (e.target.files[0]) {
// 			setFile(e.target.files[0]);
// 		}
// 	};

// 	const onUpload = async () => {
// 		if (!file) return;

// 		// const resizedFile = await resizeFile(file);
// 		uploadFile(file, storagePath, docField, docId);
// 		setFile(null);
// 		dispatch(closeDialog());
// 		dispatch(openAlert({ type: "info", message: "Caricamento..." }));
// 	};

// 	return (
// 		<div
// 			style={{
// 				backgroundColor: "white",
// 				color: "black",
// 				border: "1px solid black",
// 				padding: 20,
// 				borderRadius: 20,
// 				display: "flex",
// 				flexDirection: "column",
// 			}}
// 		>
// 			<div
// 				style={{
// 					display: "flex",
// 					flexDirection: "column",
// 					alignItems: "center",
// 				}}
// 			>
// 				<div>
// 					<input type="file" onChange={onChange} id="upload" accept="image/*,video/*" />
// 				</div>
// 				<button className="rounded" onClick={() => onUpload()}>UPLOAD</button>
// 			</div>
// 		</div>
// 	);
// };

interface Props {
    other: StudentOtherInterface;
}

export const EditCvOther: React.FC<Props> = ({other}) => {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(false);
    const {register, handleSubmit, control, errors} =
        useForm<StudentBaseOtherInterface>({
            defaultValues: {
                title: other?.title || "",
                text: other?.text || "",
                begin: other?.begin
                    ? new Date((other?.begin as DocTimestamp).seconds * 1000)
                    : null,
                end: other?.end
                    ? new Date((other?.end as DocTimestamp).seconds * 1000)
                    : null,
            },
        });
    const role = useSelector(selectRole);
    const uid = useSelector(selectUid);
    const dispatch = useDispatch();

    const onSave = (data: StudentBaseOtherInterface) => {
        let o: StudentOtherInterface = {...other};

        o = {
            ...o,
            title: data.title,
            text: data.text,
            begin: data.begin,
            end: data.end,
        };

        setLoading(true);
        updateStudentBgItem(uid, bgItemTypes.LIFE, o, !other)
            .then(() => {
                setLoading(false);
                dispatch(closeDialog());
            })
            .catch((error) => setLoading(false));
    };

    return (
        <div className="editBgOther bg-dialog">
            <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("student_other_title_label")}</div>
                    <input
                        name="title"
                        type="text"
                        ref={register({required: true})}
                    ></input>
                    {errors.title && (
                        <span className="error">{t("student_other_title_error")}</span>
                    )}
                </div>
                <div className="element">
                    <div className="label">{t("student_other_exp_label")}</div>
                    <textarea name="text" ref={register({required: true})}></textarea>
                    {errors.text && (
                        <span className="error">{t("student_other_exp_error")}</span>
                    )}
                </div>
                {role === "student" && (
                    <>
                        {/* Inizio (begin) */}
                        <div className="element">
                            <div className="label">{t("student_other_begin_label")}</div>
                            <Controller
                                control={control}
                                name="begin"
                                render={({onChange, onBlur, value}) => (
                                    <ReactDatePicker
                                        onChange={onChange}
                                        onBlur={onBlur}
                                        selected={value}
                                        dateFormat="MM/yyyy"
                                        showMonthYearPicker
                                    />
                                )}
                            />
                        </div>
                        {/* Fine (end) */}
                        <div className="element">
                            <div className="label">{t("student_other_end_label")}</div>
                            <Controller
                                control={control}
                                name="end"
                                render={({onChange, onBlur, value}) => (
                                    <ReactDatePicker
                                        onChange={onChange}
                                        onBlur={onBlur}
                                        selected={value}
                                        dateFormat="MM/yyyy"
                                        showMonthYearPicker
                                    />
                                )}
                            />
                        </div>
                    </>
                )}
                {!loading && (
                    <input
                        type="submit"
                        value={t("student_other_submit") as string}
                    ></input>
                )}
                {loading && (
                    <div className="loader">
                        <ClipLoader size={20} color={"#7400b8"} loading={true}/>
                    </div>
                )}
            </form>
        </div>
    );
};

interface RadarChartProps {
    softSkills: StudentChartSoftSkillsType;
    rmSoftSkills: StudentChartSoftSkillsType;
    onClick: Function;
}

export const RadarChart: React.FC<RadarChartProps> = ({
                                                          softSkills,
                                                          rmSoftSkills,
                                                          onClick = () => {
                                                          },
                                                      }) => {
    const initData = Object.keys(softSkillsDataset).map((tag: string) => {
        return {tag, me: 0, rm: 0};
    });
    const [data, setData] = useState(initData);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const data = Object.keys(softSkillsDataset).map((tag) => {
            const me = softSkills ? softSkills[tag] : 0;
            const rm = rmSoftSkills ? rmSoftSkills[tag] : 0;

            return {tag, me, rm};
        });

        setData(data);
    }, [softSkills, rmSoftSkills]);

    useEffect(() => {
        const handleWidth = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleWidth);
        return () => window.removeEventListener("resize", handleWidth);
    }, []);

    interface EmoticonLabelComponentProps {
        id: string;
    }

    const EmoticonLabelComponent: React.FC<EmoticonLabelComponentProps> = ({
                                                                               id,
                                                                           }) => {
        const [e, setEmoji] = useState();
        const [translate, setTranslate] = useState(0);
        const {t} = useTranslation();

        useEffect(() => {
            if (!id) return;
            const idToValues = () => {
                switch (id) {
                    case "HARD":
                        setEmoji(emojiCompact[3930]);
                        setTranslate(-80);
                        break;

                    case "SOFT":
                        setEmoji(emojiCompact[3801]);
                        setTranslate(-10);
                        break;

                    case "THOUGHTFUL":
                        setEmoji(emojiCompact[3957]);
                        setTranslate(-60);
                        break;

                    case "IMPULSIVE":
                        setEmoji(emojiCompact[3516]);
                        setTranslate(-10);
                        break;

                    case "PRAGMATIC":
                        setEmoji(emojiCompact[3386]);
                        setTranslate(-75);
                        break;

                    case "VISIONARY":
                        setEmoji(emojiCompact[411]);
                        setTranslate(-5);
                        break;

                    case "LEADER":
                        setEmoji(emojiCompact[3364]);
                        setTranslate(-40);
                        break;

                    case "FOLLOWER":
                        setEmoji(emojiCompact[3817]);
                        setTranslate(-45);
                        break;

                    default:
                        break;
                }
            };
            idToValues();
        }, [id]);

        return (
            <g transform={`translate(${translate}, -20)`}>
                <text
                    y={24}
                    style={{
                        fontSize: 13,
                        fontWeight: 500,
                        fill: "#161616",
                        width: 10,
                        height: 20,
                    }}
                >
                    {/* <tspan x="0">{id.split(" ")[0]}</tspan>
			{id.indexOf(' ') >= 0 && <tspan x="0" dy="1.2em">{id.split(" ")[1]}</tspan>} */}
                    <tspan x="0">
                        {e + " " + t(softSkillsDataset[id].label as string)}
                    </tspan>
                </text>
            </g>
        );
    };

    interface EmoticonComponentProps {
        id: string;
    }

    const EmoticonComponent: React.FC<EmoticonComponentProps> = ({id}) => {
        const [e, setEmoji] = useState();

        const idToValues = () => {
            switch (id) {
                case "HARD":
                    setEmoji(emojiCompact[3930]);
                    break;

                case "SOFT":
                    setEmoji(emojiCompact[3801]);
                    break;

                case "THOUGHTFUL":
                    setEmoji(emojiCompact[3957]);
                    break;

                case "IMPULSIVE":
                    setEmoji(emojiCompact[3516]);
                    break;

                case "PRAGMATIC":
                    setEmoji(emojiCompact[3386]);
                    break;

                case "VISIONARY":
                    setEmoji(emojiCompact[411]);
                    break;

                case "LEADER":
                    setEmoji(emojiCompact[3364]);
                    break;

                case "FOLLOWER":
                    setEmoji(emojiCompact[3817]);
                    break;

                default:
                    break;
            }
        };

        useEffect(() => {
            if (!id) return;
            idToValues();
        }, [id]);

        return (
            <g transform={`translate(${-10}, -20)`}>
                <text
                    y={24}
                    style={{
                        fontSize: 20,
                        fontWeight: 500,
                        fill: "#161616",
                        width: 10,
                        height: 20,
                    }}
                >
                    {/* <tspan x="0">{id.split(" ")[0]}</tspan>
			{id.indexOf(' ') >= 0 && <tspan x="0" dy="1.2em">{id.split(" ")[1]}</tspan>} */}
                    <tspan x="0">{e}</tspan>
                </text>
            </g>
        );
    };

    return (
        <div
            style={{height: "350px", width: "100%"}}
            className="radarChart"
            onClick={() => onClick()}
        >
            <AutoSizer>
                {({height, width}) => (
                    <Radar
                        height={height}
                        width={width}
                        data={data}
                        keys={["me", "rm"]}
                        maxValue={10}
                        indexBy="tag"
                        margin={
                            windowWidth > 768
                                ? {top: 50, right: 100, bottom: 30, left: 100}
                                : {top: 0, right: 40, bottom: 0, left: 40}
                        }
                        curve="linearClosed"
                        borderWidth={5}
                        dotBorderColor={{from: "color"}}
                        colors={["#FFAB47", "#309DFF"]}
                        fillOpacity={1}
                        enableDots={false}
                        dotBorderWidth={5}
                        // dotBorderColor={"#7366FF"}
                        gridLevels={5}
                        gridShape="linear"
                        gridLabelOffset={20}
                        blendMode="multiply"
                        animate={true}
                        // motionStiffness={90}
                        // motionDamping={15}
                        isInteractive={false}
                        gridLabel={
                            windowWidth > 768 ? EmoticonLabelComponent : EmoticonComponent
                        }
                    />
                )}
            </AutoSizer>
        </div>
    );
};

interface AlertProps {
    type: "success" | "info" | "warning" | "error";
    message: string;
}

export const Alert: React.FC<AlertProps> = ({type, message}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(closeAlert());
        }, 5000);
        return () => clearTimeout(timer);
    }, [dispatch]);

    return (
        <div className="alert">
            <Snackbar open={true}>
                <MuiAlert severity={type} elevation={6} variant="filled">
                    {message}
                </MuiAlert>
            </Snackbar>
        </div>
    );
};

export const EditStudentInfo = () => {
	const user = useSelector(selectUser);
	const uid = useSelector(selectUid);
	const { register, handleSubmit, control, errors } = useForm<MissingType>({
		defaultValues: {
			description: user.description || "",
			birthday: user.birthday ? new Date(user.birthday.seconds * 1000) : null,
			genderId: user.genderId || null,
			city: user.city || "",
			website: sanitizeUrl(user.website) || "",
			studyScope: user.studyScope,
			interestScopes: (user?.interestScopes || []).map(
				(s: number) => professionScopes[s]
			),
		},
	});
	const [interestScopesCount, setInterestScopesCount] = useState(0);
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const onSaveStudentInfo = (form: MissingType) => {
		const s: StudentInterface = {
			...user,
			description: form.description,
			genderId: Number(form.genderId),
			city: form.city,
			birthday: moment(form.birthday).toDate(),
			website: sanitizeUrl(form.website),
			studyScope: Number(form.studyScope),
			interestScopes: form.interestScopes.map(
				(s: { id: number; label: string }) => s.id
			),
		};
		updateStudent(s).then(() => {
			if (form.photo.length > 0) {
				const photo = form.photo[0];
				// const resizedFile = await resizeFile(photo);
				uploadFile(
					photo,
					`${uid}/profile/photo`,
					"photoUrl",
					`${Collections.USERS}/${uid}`
				);
			}
			dispatch(closeDialog());
		});
	};

	return (
		<div className="editUserInfo bg-dialog">
			<div style={{ display: "flex", flexDirection: "column" }}>
				<form onSubmit={handleSubmit(onSaveStudentInfo)}>
					<div className="element">
						<div className="label">{t("student_editInfo_photo_label")}</div>
						<input type="file" accept="image/*" name="photo" ref={register} />
					</div>
					<div className="element">
						<div className="label">{t("student_editInfo_gender_label")}</div>
						<select name="genderId" ref={register({ required: true })}>
							<option selected value="">
								{t("select_choose_option")}
							</option>
							{genderDataset.map((gender) => (
								<option key={gender.id} value={gender.id}>
									{t(gender.label)}
								</option>
							))}
						</select>
						{errors.genderId && (
							<span className="error">
								{t("student_editInfo_gender_error")}
							</span>
                        )}
                    </div>
                    <div className="element">
                        <div className="label">
                            {t("student_editInfo_studyScope_label")}
                        </div>
                        <select name="studyScope" ref={register}>
                            <option selected value={-1}>
                                {t("select_choose_option")}
                            </option>
                            {qualificationScopes.map((sc) => (
                                <option key={sc.id} value={sc.id}>
                                    {t(sc.label)}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="element">
                        <div className="label">{t("student_editInfo_interests_label")}</div>
                        <Controller
                            render={({onChange, ...props}) => (
                                <Autocomplete
                                    {...props}
                                    multiple
                                    filterSelectedOptions
                                    getOptionDisabled={(options) =>
                                        interestScopesCount > 2 ? true : false
                                    }
                                    options={professionScopes}
                                    getOptionLabel={(option) => t(option.label)}
                                    renderInput={(params) => <TextField {...params} />}
                                    onChange={(e, x) => {
                                        onChange(x);
                                        if (x) setInterestScopesCount(x.length);
                                    }}
                                />
                            )}
                            onChange={(_: MissingType, data: MissingType) => data}
                            defaultValue={[]}
                            name={"interestScopes"}
                            // rules={{ required: true }}
                            control={control}
                        />
                    </div>
                    <div className="element">
                        <div className="label">{t("student_editInfo_website_label")}</div>
                        <input
                            type="text"
                            placeholder={t("student_editInfo_website_ph")}
                            name="website"
                            ref={register}
                        />
                    </div>
                    <div className="element">
                        <div className="label">{t("student_editInfo_birthday_label")}</div>
                        <Controller
                            control={control}
                            name="birthday"
                            rules={{required: true}}
                            render={({onChange, onBlur, value}) => (
                                <ReactDatePicker
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    selected={value}
                                    dateFormat="dd/MM/yyyy"
                                    minDate={new Date(1970, 0, 1)}
                                    maxDate={new Date()}
                                    showMonthDropdown
                                    showYearDropdown
                                />
                            )}
                        />
                        {errors.birthday && (
                            <span className="error">
								{t("student_editInfo_birthday_error")}
							</span>
                        )}
                    </div>
                    <div className="element">
                        <div className="label">{t("student_editInfo_city_label")}</div>
                        <input
                            type="text"
                            placeholder={t("student_editInfo_city_ph")}
                            name="city"
                            ref={register}
                        />
                    </div>
                    <div className="element">
                        <div className="label">{t("student_editInfo_desc_label")}</div>
                        <textarea
                            placeholder={t("student_editInfo_desc_ph")}
                            style={{margin: 5}}
                            name="description"
                            ref={register}
                            rows={6}
                        />
                    </div>
                    <input
                        type="submit"
                        value={t("student_editInfo_submit") as string}
                    ></input>
                </form>
            </div>
        </div>
    );
};

export const EditCompanyInfo = () => {
    const user = useSelector(selectUser);
    const uid = useSelector(selectUid);
    const {register, handleSubmit, errors} = useForm({
        defaultValues: {
            name: user.name,
            sector: user.sector,
            mission: user.mission || "",
            dimension: user.dimension,
            headquarter: user.headquarter || "",
            website: sanitizeUrl(user.website) || "",
            primaryColor: user.primaryColor || "",
            secondaryColor: user.secondaryColor || "",
            rmTerms: sanitizeUrl(user.rmTerms) || "",
        },
    });
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const onSaveCompanyInfo = (form: MissingType) => {
        const c = {
            ...user,
            sector: Number(form.sector),
            mission: form.mission,
            headquarter: form.headquarter,
            website: sanitizeUrl(form.website),
            name: form.name,
            dimension: Number(form.dimension),
            primaryColor: form.primaryColor,
            secondaryColor: form.secondaryColor,
            rmTerms: form.rmTerms,
        };
        updateCompany(c, user.name !== c.name).then(async () => {
            if (form.logo.length > 0) {
                // const resizedFile = await resizeFile(form.logo[0]);
                uploadFile(
                    form.logo[0],
                    `${uid}/profile/logo`,
                    `logoUrl`,
                    `${Collections.USERS}/${uid}`
                );
                dispatch(closeDialog());
            } else {
                dispatch(closeDialog());
            }
        });
    };

    return (
        <div className="editUserInfo bg-dialog">
            <form onSubmit={handleSubmit(onSaveCompanyInfo)}>
                <div className="element">
                    <div className="label">{t("company_editInfo_logo_label")}</div>
                    <input type="file" name="logo" accept="image/*" ref={register}/>
                </div>
                <div className="element">
                    <div className="label">{t("company_editInfo_name_label")}</div>
                    <input
                        type="text"
                        placeholder={t("company_editInfo_name_ph")}
                        name="name"
                        ref={register({required: true})}
                    />
                    {errors.name && (
                        <p className="error">{t("company_editInfo_name_error")}</p>
                    )}
                </div>
                <div className="element">
                    <div className="label">{t("company_editInfo_sector_label")}</div>
                    <select name="sector" ref={register({required: true})}>
                        {companySectors.map((item, index) => (
                            <option value={item.id} key={item.id}>
                                {t(item.label)}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="element">
                    <div className="label">{t("company_editInfo_headquarter_label")}</div>
                    <input
                        type="text"
                        placeholder={t("company_editInfo_headquarter_ph")}
                        name="headquarter"
                        ref={register}
                    />
                </div>
                <div className="element">
                    <div className="label">{t("company_editInfo_dimension_label")}</div>
                    <select name="dimension" ref={register}>
                        {companyDimensions.map((item, index) => (
                            <option value={item.id} key={item.id}>
                                {item.label}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="element">
                    <div className="label">{t("company_editInfo_website_label")}</div>
                    <input
                        type="text"
                        placeholder={t("company_editInfo_website_ph")}
                        name="website"
                        ref={register}
                    />
                </div>
                <div className="element">
                    <div className="label">{t("company_editInfo_mission_label")}</div>
                    <textarea
                        placeholder={t("company_editInfo_mission_ph")}
                        name="mission"
                        ref={register}
                    ></textarea>
                </div>
                <div className="element">
                    <div className="label">{t("company_editInfo_privacy_label")}</div>
                    <input
                        type="text"
                        placeholder={t("company_editInfo_privacy_ph")}
                        name="rmTerms"
                        ref={register}
                    />
                </div>
                <div className="element">
                    <div className="label">
                        {t("company_editInfo_primaryColor_label")}
                    </div>
                    <input
                        type="text"
                        placeholder={t("company_editInfo_primaryColor_ph")}
                        name="primaryColor"
                        ref={register}
                    />
                </div>
                <div className="element">
                    <div className="label">
                        {t("company_editInfo_secondaryColor_label")}
                    </div>
                    <input
                        type="text"
                        placeholder={t("company_editInfo_secondaryColor_ph")}
                        name="secondaryColor"
                        ref={register}
                    />
                </div>
                <input
                    type="submit"
                    value={t("company_editInfo_submit") as string}
                ></input>
            </form>
        </div>
    );
};

// export const AddPhoto = ({ storagePath, docFieldPath, docPath }) => {
// 	return (
// 		<div className="editPhotoGallery bg-dialog">
// 			<div>
// 				<h4>Foto</h4>
// 				<FileUploader
// 					storagePath={storagePath}
// 					docField={docFieldPath}
// 					docId={docPath}
// 				/>
// 			</div>
// 		</div>
// 	);
// };

interface CompanyAreasProps {
    areas: CompanyAreaI[];
    companyId: string;
}

export const CompanyAreas: React.FC<CompanyAreasProps> = ({
                                                              areas,
                                                              companyId,
                                                          }) => {
    const {t} = useTranslation();

    return (
        <div className="companyAreas">
            {areas.length > 0 &&
                areas.map((area, areaIndex) => (
                    <CompanyArea key={area.id} area={area} companyId={companyId}/>
                ))}
            {areas.length === 0 && <p>{t("company_vivaio_areas_none")}</p>}
        </div>
    );
};

interface ConfirmActionProps {
    action: Function;
}

export const ConfirmAction: React.FC<ConfirmActionProps> = ({action}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const onAction = () => {
        action();
        dispatch(closeDialog());
    };

    return (
        <div className="confirmAction">
            <p>{t("confirm_text")}</p>
            <div className="confirmAction__actions">
                <Button
                    onClick={() => onAction()}
                    // style={{ backgroundColor: "#00E60E" }}
                    filled={true}
                >
                    {t("confirm_ok")}
                </Button>
                <Button
                    onClick={() => dispatch(closeDialog())}
                    // style={{ backgroundColor: "#E83800" }}
                >
                    {t("confirm_cancel")}
                </Button>
            </div>
        </div>
    );
};

export const ForgotPassword = () => {
    const {register, handleSubmit, errors} = useForm({
        defaultValues: {email: ""},
    });
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const onSave = (form: MissingType) => {
        auth
            .sendPasswordResetEmail(form.email)
            .then(() => {
                dispatch(
                    openAlert({type: "success", message: t("alert_email_sent")})
                );
                dispatch(closeDialog());
            })
            .catch((error) => {
                dispatch(
                    openAlert({type: "error", message: t("alert_generic_error")})
                );
            });
    };

    return (
        <div>
            <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("forgotPsw_email_label")}</div>
                    <input type="email" name="email" ref={register({required: true})}/>
                    {errors.email && <p>{t("forgotPsw_email_error")}</p>}
                </div>
                <input type="submit" value={t("forgotPsw_submit") as string}/>
            </form>
        </div>
    );
};

interface SignupSuccessProps {
    message: string;
}

export const SignupSuccess: React.FC<SignupSuccessProps> = ({message}) => {
    return (
        <div className="signupSuccess">
            <div className="title">Complimenti!</div>
            <div className="subtitle">
                La registrazione è stata completata con successo.
            </div>
            <p>{message}</p>
        </div>
    );
};
